/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import {createLevel, updateLevel, deleteLevel} from '../../../api/modules/userlevel'
import axios from 'axios'
import Accordion from 'react-bootstrap/Accordion'
import swal from 'sweetalert'
import Pagination from '../component/Pagination'
import {getAccessesUserLevel} from '../../../api/modules/access/access'
import {Spinner} from 'react-bootstrap'
import {
  fetchApprovalLevelList,
  fetchUserLevelList,
  fetchUserLevels,
  headers,
} from '../../../services/fetcher'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {objToParams} from '../../../utils/objToParams'
import {RowFilter} from './RowFilter'
import {
  filterSelector,
  resetFilterUserLevel,
  setFilterUserLevel,
  setIsFetchData,
} from '../../../redux/slices/filterSlices'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {useRowTable} from '../../../hooks/useRowTable'
import * as TableUI from '../../../components/Table/Table'
import {StyledCard} from '../../../components/StyledCard'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import {useLoaderList} from 'src/hooks/useLoaderList'
import {ActionIcon, AppButton} from 'src/components'
import {SkeletonForm} from 'src/components/Skeletons'

type Props = {
  className: string
}

interface IApprovalLevel {
  title: string
  data: {
    id: number
    label: string
  }[]
}

interface IUserLevel {
  id: number
  name: string
  created_at: string
  updated_at: string
  approval_ids: number[]
  approvals: {
    id: number
    sales_org_code: string
    level: number
    min_quantity: number
    max_quantity: number
    created_at: string
    updated_at: string
    type_approval: string
    product_type: string | null
    type_penjualan: string
    payment_type: string | null
    sector_id: number | null
    pivot: {
      user_level_id: number
      approval_level_id: number
    }
    sales_organization: {
      id: number
      code: string
      name: string
      created_at: string
      updated_at: string | null
    }
  }[]
}
const UserLevel: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {roleId} = useAppSelector(authSelector)
  const {filterUserLevel} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 3,
    onReloadTable: () => handleResetTable(),
  })

  const {
    isLoadingEditButton,
    onInitializeLoaderList,
    onResetLoaderList,
    onUpdateLoaderListByIndex,
  } = useLoaderList()

  const [btnLoading, setBtnLoading] = useState(false)

  const [showDetail, setShowDetail] = useState(false)
  const [showAdd, setShowAdd] = useState(false)
  const [showDelete, setShowDelete] = useState(false)

  const [userData, setUserData] = useState<IUserLevel[]>([])

  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [levelList, setLevelList] = useState<IApprovalLevel[]>([])
  const [addName, setAddName] = useState('')
  const [approval, setApproval] = useState<any>([])
  const [loading2, setLoading2] = useState(false)
  const [ID, setID] = useState(0)
  const [accesses, setAccesses] = useState<any>()
  const [actived, setActived] = useState(false)
  const [page, setPage] = useState(1)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const rowNumber = useMemo(() => {
    const per = filterUserLevel?.per_page ?? 5
    return page * per - per
  }, [filterUserLevel, page])

  useEffect(() => {
    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccessesUserLevel(roleId)
      setAccesses(res.data.data)
    }

    getAccessMenu()
  }, [])

  const paginateNumber = async (url: string) => {
    try {
      setIsLoading(true)

      const endpoint = `${url}&${objToParams(filterUserLevel)}`
      const token = localStorage.getItem('token') as string
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })

      setUserData(res.data.data.data)
      setNumberURL(res.data.data.links)
      setPage(res.data.data.current_page)
      onInitializeLoaderList(res.data.data.data)
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  const handleChecked = (id: any) => {
    setLoading2(true)
    const tempArray: any[] = [...approval]
    const ckbox = document.getElementById(`id${id}`) as HTMLInputElement
    if (ckbox.checked) tempArray.push(id)
    else {
      const tempIndex = tempArray.indexOf(id)
      tempArray.splice(tempIndex, 1)
    }
    setApproval(tempArray)
    setLoading2(false)
  }

  const postLevel = async () => {
    setBtnLoading(true)
    await createLevel({name: addName, approval_order: approval})
      .then((res) => {
        setShowAdd(false)
        setActived(!actived)
        setApproval([])
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
      })
      .then(() => onFetchUserLevel())
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const editLevel = async () => {
    setBtnLoading(true)
    await updateLevel(ID, {name: addName, approval_order: approval})
      .then((res) => {
        setShowDetail(false)
        setApproval([])
        setActived(!actived)
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
      })
      .then(() => onFetchUserLevel())
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleDelete = async (id: any) => {
    swal({
      title: t('Are you sure?'),
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteLevel(id)
          .then((res) => {
            swal({
              title: t('success deleting user level'),
              icon: 'success',
            })
            setShowDelete(false)
            setApproval([])
            setActived(!actived)
          })
          .then(() => onFetchUserLevel())
          .catch(function (error) {
            if (error.response) {
              swal({
                title: `${error.response.data.message}`,
                icon: 'error',
              })
            }
          })
          .finally(() => {
            setBtnLoading(false)
          })
      }
    })
  }

  const dropLevel = async () => {
    setBtnLoading(true)
    await deleteLevel(ID)
      .then((res) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
        setShowDelete(false)
        setApproval([])
        setActived(!actived)
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${error.response.data.message}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [isAddButtonLoading, setIsAddButtonLoading] = useState(false)

  const onFetchApprovalLevelList = async () => {
    try {
      const res = await fetchApprovalLevelList()
      setLevelList(res.data.data)
    } catch (error: any) {
      swal({
        title: `${error.response.data.message}`,
        icon: 'error',
      })
    } finally {
      onResetLoaderList()
      setIsAddButtonLoading(false)
    }
  }

  const onFetchUserLevel = useCallback(() => {
    setIsLoading(true)
    setIsError(false)

    fetchUserLevels(filterUserLevel)
      .then((res) => {
        setUserData(res.data.data.data)
        setNumberURL(res.data.data.links)
        setPage(res.data.data.current_page)
        onInitializeLoaderList(res.data.data.data)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setIsLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterUserLevel, dispatch])

  useEffect(() => {
    const getData = setTimeout(onFetchUserLevel, 1000)
    return () => clearTimeout(getData)
  }, [onFetchUserLevel])

  const title = (data: any) => {
    return data
      .replace('Kontrak', t('Kontrak'))
      .replace('Domestic Retail', t('Domestik Retail'))
      .replace('Domestic Korporasi', t('Domestik Korperasi'))
      .replace('Export', t('Export'))
      .replace('Product Lainnya', t('Product Lainnya'))
  }

  const item = (data: any) => {
    return data
      .replaceAll('Ton ', t('Tonase'))
      .replaceAll('Tonase', t('Tonase'))
      .replaceAll('Tak terbatas', t('Tak terbatas'))
      .replaceAll('Penjualan Tanpa Jaminan', t('Penjualan Tanpa Jaminan'))
      .replaceAll('Cash Payment', t('Cash Payment'))
      .replaceAll('Distributor Financing', t('Distributor Financing'))
      .replaceAll('L/C Without DP', t('L/C Without DP'))
      .replaceAll('All Payment', t('All Payment'))
  }

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterUserLevel({...filterUserLevel, per_page: value ?? 5}))
  }

  const handleResetTable = () => {
    dispatch(resetFilterUserLevel())
  }

  useEffect(() => {
    return () => {
      handleResetTable()
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterUserLevel?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
        rightContent={
          hakAkses?.create && (
            <AppButton
              text={
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  <p>{t('kontrak-tambah') + ' ' + t('User Level')}</p>
                </div>
              }
              isLoading={isAddButtonLoading}
              disabled={isAddButtonLoading}
              onClick={() => {
                setIsAddButtonLoading(true)
                onFetchApprovalLevelList()
                setShowAdd(true)
              }}
            />
          )
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('nama')}</th>
              {(hakAkses?.update || hakAkses?.delete) && <th>{t('order-aksi')}</th>}
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {isLoading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : userData.length === 0 ? (
              <RowEmptyData />
            ) : (
              userData.map((data: any, _index: any) => (
                <tr key={data?.id ?? _index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>{data.name}</td>
                  {hakAkses?.update || hakAkses?.delete ? (
                    <td>
                      {hakAkses?.update && (
                        <ActionIcon
                          className='me-2'
                          title={t('ubah')}
                          iconPath='/media/icons/duotune/gear-fill.svg'
                          isLoading={isLoadingEditButton(_index)}
                          disabled={isLoadingEditButton(_index)}
                          onClick={() => {
                            onFetchApprovalLevelList()
                            setApproval(data.approval_ids)
                            setAddName(data.name)
                            setID(data.id)
                            setShowDetail(true)
                            onUpdateLoaderListByIndex(_index)
                          }}
                        />
                      )}
                      {hakAkses?.delete && (
                        <button
                          onClick={() => {
                            setID(data.id)
                            handleDelete(data.id)
                          }}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          title={t('Hapus')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      )}
                    </td>
                  ) : (
                    <></>
                  )}
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showDetail}
        onHide={() => {
          setShowDetail(false)
          setApproval([])
        }}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>Ubah Level Pengguna</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='mb-5'>
            <Col sm={4}>
              <h6 className='mt-4'>{t('nama')}</h6>
            </Col>
            <Col sm={8}>
              <Form.Control
                type='text'
                defaultValue={addName}
                onChange={(e: any) => setAddName(e.target.value)}
              />
            </Col>
          </Row>

          {levelList?.map((level, index) => {
            return (
              <Accordion key={index}>
                <Accordion.Item eventKey={index.toString()}>
                  <Accordion.Header>{title(level?.title ?? '-')}</Accordion.Header>
                  <Accordion.Body style={{backgroundColor: '#fff'}}>
                    {level?.data?.map((item, index) => {
                      return (
                        <Row className='mb-5' key={item?.id ?? index}>
                          <Col sm={10}>
                            <p className='mt-4'>{item.label}</p>
                          </Col>
                          <Col sm={2} className='d-flex justify-content-end'>
                            {!loading2 && (
                              <input
                                className='form-check-input mt-4'
                                type='checkbox'
                                id={'id' + item?.id}
                                key={item.id}
                                defaultChecked={approval?.includes(item?.id)}
                                onClick={() => handleChecked(item?.id)}
                              />
                            )}
                          </Col>
                        </Row>
                      )
                    })}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )
          })}

          <div className='d-flex justify-content-end mt-5'>
            <Button
              className=''
              variant='primary'
              onClick={() => editLevel()}
              disabled={btnLoading}
            >
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('ubah')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showAdd}
        onHide={() => {
          setShowAdd(false)
          setApproval([])
        }}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('add')} {t('User Level')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isAddButtonLoading ? (
            <SkeletonForm />
          ) : (
            <>
              <Row className='mb-5'>
                <Col sm={4}>
                  <h6 className='mt-4'>{t('nama')}</h6>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    type='text'
                    placeholder={t('nama')}
                    onChange={(e: any) => setAddName(e.target.value)}
                  />
                </Col>
              </Row>

              {levelList?.map((level, _index) => {
                return (
                  <Accordion key={_index}>
                    <Accordion.Item eventKey={_index.toString()}>
                      <Accordion.Header>{title(level?.title)}</Accordion.Header>
                      <Accordion.Body style={{backgroundColor: '#fff'}}>
                        {level?.data?.map((subdata, index) => {
                          return (
                            <Row className='mb-5' key={index}>
                              <Col sm={10}>
                                <p className='mt-4'>{item(subdata?.label)}</p>
                              </Col>
                              <Col sm={2} className='d-flex justify-content-end'>
                                <input
                                  className='form-check-input mt-4'
                                  type='checkbox'
                                  id={'id' + subdata?.id}
                                  onClick={() => handleChecked(subdata?.id)}
                                />
                              </Col>
                            </Row>
                          )
                        })}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                )
              })}

              <div className='d-flex justify-content-end mt-5'>
                <Button variant='primary' onClick={() => postLevel()} disabled={btnLoading}>
                  {btnLoading ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    t('order-tambah')
                  )}
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered backdrop='static'>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h3 className='text-center mb-5'>
            {t('Delete')} {t('User Level')}?
          </h3>
          <div className='d-flex justify-content-center'>
            <Button
              variant='secondary me-2'
              disabled={btnLoading}
              onClick={() => setShowDelete(false)}
            >
              {t('Tidak')}
            </Button>
            {btnLoading ? (
              <Spinner animation='border' variant='light' size='sm' />
            ) : (
              <Button variant='danger' onClick={() => dropLevel()} disabled={btnLoading}>
                {t('Ya')}
              </Button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {UserLevel}
